<template>
    <main class="grace-container">
        <section class="slogan">
            <div class="slogan-img"></div>
            <div class="slogan-img-shadow"></div>
            <div class="main-title-wrapper">
                <div class="main-title-wrapper-left">
                    <div class="main-title">{{ $t('lp-reg7') }}</div>
                    <div class="main-subtitle">{{ $t('lp-reg8') }}</div>
                </div>
                <div class="main-title-wrapper-right"></div>
            </div>
        </section>

        <div class="mobileapp-container mobileapp-container-short2">
            <div class="registration-wrapper">
                <div class="registration-left">
                    <i18n path="lp-reg21" class="reg-title" tag="div">
                        <span place="promoCode">AmforaInvest</span>
                    </i18n>
                    <div class="reg-valid">{{ $t('lp-reg22') }}</div>
                    <i18n path="lp-reg23" class="reg-info" tag="div">
                        <a href="mailto:invest@vindome.net" place="investMail">invest@vindome.net</a>
                    </i18n>
                </div>
                <div class="registration-right">
                    <div v-if="!nextStep">
                        <v-flex v-if="isBrowser">
                            <span class="login-label">{{ $t('myprofile1') }} *</span>
                            <v-text-field
                                id="regFName"
                                ref="regFName"
                                v-model="regFName"
                                class="email-input"
                                :rules="[rules.required]"
                                :error="$v.regFName.$error"
                            ></v-text-field>
                        </v-flex>

                        <v-flex v-if="isBrowser">
                            <span class="login-label">{{ $t('myprofile2') }} *</span>
                            <v-text-field
                                v-model="regLName"
                                class="email-input"
                                :rules="[rules.required]"
                                :error="$v.regLName.$error"
                            ></v-text-field>
                        </v-flex>

                        <v-flex>
                            <span class="login-label">{{ $t('email') }} *</span>
                            <v-text-field
                                ref="email"
                                v-model="regEmail"
                                class="email-input"
                                :rules="[rules.required, rules.emailValid]"
                            ></v-text-field>
                        </v-flex>
                        <v-flex>
                            <span class="login-label">{{ $t('password') }} *</span>
                            <v-text-field
                                ref="regPassword"
                                v-model="regPassword"
                                :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="secureRegPassword ? 'password' : 'text'"
                                name="input-10-1"
                                hint="At least 8 characters"
                                @click:append="secureRegPassword = !secureRegPassword"
                                v-on:keyup.enter="registration"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-checkbox
                            v-model="checked18"
                            class="check-terms check-terms2"
                            :label="$t('register-confirm18')"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="checkedTerms"
                            class="check-terms"
                        >
                            <div slot="label">
                                {{ $t('register-terms') }}
                            </div>
                        </v-checkbox>
                        <v-checkbox
                            v-model="checkedNews"
                            :label="$t('register-news')"
                            class="check-terms"
                        ></v-checkbox>
                        <v-flex>
                            <div class="errors-container2" v-if="errorMsg !== ''">
                                <p>{{ errorMsg }}</p>
                            </div>
                        </v-flex>
                        <v-flex>
                            <v-btn class="submit login-submit" v-on:click="registration">{{ $t('lp-reg24') }}</v-btn>
                        </v-flex>
                    </div>
                    <div v-else>
                        <div class="login-success">
                            <h2>Success!</h2>
                            <div class="additional-info">
                                Check your email for an account activation link!
                            </div>
                        </div>

                        <div class="login-success-btn-wrapper">
                            <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                            <v-btn class="btn-bid-cancel" v-on:click="resendMail">Resend email</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h2 class="home-title-wine">{{ $t('lp-grace4') }}</h2>
        <div class="mobileapp-container mobileapp-container-short" v-if="!mobileCheck">
            <div class="how-it-works-row">
                <div class="how-it-works-row-center icon1"></div>
                <div class="how-it-works-row-right">
                    <div class="how-title how-title1">{{ $t('lp-grace5') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace6') }}</div>
                </div>
            </div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row">
                <div class="how-it-works-row-center icon2"></div>
                <div class="how-it-works-row-right">
                    <div class="how-title">{{ $t('lp-grace7-1') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace8') }}</div>
                </div>
            </div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row">
                <div class="how-it-works-row-center icon3"></div>
                <div class="how-it-works-row-right">
                    <div class="how-title">{{ $t('lp-grace9') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace10') }}</div>
                </div>
            </div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row">
                <div class="how-it-works-row-center icon4"></div>
                <div class="how-it-works-row-right">
                    <div class="how-title">{{ $t('lp-grace11') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace12') }}</div>
                </div>
            </div>
        </div>
        <div class="mobileapp-container" v-else>
            <div class="how-it-works-row-center icon1"></div>
            <div class="how-title how-title1">{{ $t('lp-grace5') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace6') }}</div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row-center icon2"></div>
            <div class="how-title">{{ $t('lp-grace7') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace8') }}</div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row-center icon3"></div>
            <div class="how-title">{{ $t('lp-grace9') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace10') }}</div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row-center icon4"></div>
            <div class="how-title">{{ $t('lp-grace11') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace12') }}</div>
            <div class="start-btn" v-on:click="goToDownload">{{ $t('lp-grace13') }}</div>
        </div>

        <section class="last-section">
            <div class="mobileapp-container" v-if="!mobileCheck">
                <h2 class="home-title-wine">{{ $t('why-choose-vindome') }}</h2>

                <div class="invest-row">
                    <div class="invest-box">
                        <div class="invest-icon"></div>
                        <div class="invest-title">{{ $t('lp-reg9') }}</div>
                        <div class="invest-text">{{ $t('lp-reg10') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon"></div>
                        <div class="invest-title">{{ $t('lp-reg11') }}</div>
                        <div class="invest-text">{{ $t('lp-reg12') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon"></div>
                        <div class="invest-title">{{ $t('lp-reg13') }}</div>
                        <div class="invest-text">{{ $t('lp-reg14') }}</div>
                    </div>
                </div>

                <div class="invest-row">
                    <div class="invest-box">
                        <div class="invest-icon"></div>
                        <div class="invest-title">{{ $t('lp-reg15') }}</div>
                        <div class="invest-text">{{ $t('lp-reg16') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon"></div>
                        <div class="invest-title">{{ $t('lp-reg17') }}</div>
                        <div class="invest-text">{{ $t('lp-reg18') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon"></div>
                        <div class="invest-title">{{ $t('lp-reg19') }}</div>
                        <div class="invest-text">{{ $t('lp-reg20') }}</div>
                    </div>
                </div>
            </div>
            <div class="mobileapp-container" v-else>
                <h2 class="home-title-wine">{{ $t('why-choose-vindome') }}</h2>

                <swiper :options="swiperOptionMobile">
                    <swiper-slide v-for="(item, index) in swiperData2" :key="index">
                        <div class="invest-box">
                            <div class="invest-icon"></div>
                            <div class="invest-title" v-html="item.article"></div>
                            <div class="invest-text" v-html="item.value"></div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </section>
    </main>
</template>

<script>
import {email, minLength, required} from "vuelidate/lib/validators";
import {mapActions, mapGetters} from "vuex";
import {AAuth} from "@/store/actions";
import {GCommon} from "@/store/getters";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import axios from "axios";

export default {
    name: "LpTest",
    head: {
        title: 'Invest registration campaign #4 | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'page-landing-grace'
        }
    },
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    validations: {
        regFName: {
            required
        },
        regLName: {
            required
        },
        regEmail: {
            required,
            email
        },
        regPassword: {
            required,
            minLength: minLength(8)
        }
    },
    computed: {
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION
        })
    },
    data () {
        return {
            isBrowser: false,
            regEmail: '',
            regPassword: '',
            regFName: '',
            regLName: '',
            countryId: 224,
            isLoading: false,
            checkedTerms: false,
            checked18: false,
            checkedNews: true,
            secureRegPassword: true,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                emailValid: value => this.isEmailValid(value) || 'Invalid email'
            },
            errorMsg: '',
            nextStep: false,
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 60,
                loop: false
            },
            swiperOptionMobile: {
                slidesPerView: 1,
                spaceBetween: 60,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                }
            },
            swiperData2: [
                {
                    name: '1',
                    article: this.$i18n.t('lp-reg9'),
                    value: this.$i18n.t('lp-reg10')
                },
                {
                    name: '2',
                    article: this.$i18n.t('lp-reg11'),
                    value: this.$i18n.t('lp-reg12')
                },
                {
                    name: '3',
                    article: this.$i18n.t('lp-reg13'),
                    value: this.$i18n.t('lp-reg14')
                },
                {
                    name: '4',
                    article: this.$i18n.t('lp-reg15'),
                    value: this.$i18n.t('lp-reg16')
                },
                {
                    name: '5',
                    article: this.$i18n.t('lp-reg17'),
                    value: this.$i18n.t('lp-reg18')
                },
                {
                    name: '6',
                    article: this.$i18n.t('lp-reg19'),
                    value: this.$i18n.t('lp-reg20')
                }
            ]
        }
    },
    methods: {
        goToLogin() {
            this.$router.push(this.localePath({ path: '/login' }));
        },
        isEmailValid: function (email) {
            return this.reg.test(email)
        },
        goToDownload() {
            window.scrollTo({
                top: 370,
                left: 0,
                behavior: 'smooth'
            });
        },
        resendMail() {
            this.sendMail(this.regEmail)
        },
        registration() {
            let _ctrl = this;
            this.$v.regFName.$touch();
            this.$v.regLName.$touch();

            if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                if (this.checkedTerms && this.checked18) {
                    this.isLoading = true;
                    let payload = {
                        email: this.regEmail,
                        password: this.regPassword,
                        confirmPassword: this.regPassword,
                        firstname: this.regFName,
                        lastname: this.regLName,
                        countryId: this.countryId,
                        phoneNumber: '+ 1',
                        name: '',
                        enabledNotification: this.enabledNotification === true ? 1 : 0,
                        newsletter: this.checkedNews
                    };

                    this.signup(payload).then(res => {
                        if (res.statusCode === 400) {
                            this.isLoading = false;
                            this.errorMsg = 'Email is already in use.';
                        } else {
                            if (res.reasonPhrase === "Created") {
                                this.nextStep = true;
                            }

                            let options = {
                                method: 'POST',
                                url: 'https://forms.raketa.cloud/submit/NcDv6mP6me',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json;charset=UTF-8'
                                },
                                data: {
                                    data: {
                                        email: _ctrl.regEmail,
                                        message: "Amfora"
                                    }
                                }
                            };
                            axios(options);

                            this.$gtm.push({ event: "registration" });
                            window.fbq('track', 'CompleteRegistration');
                            window.uetq = window.uetq || [];
                            window.uetq.push("event", "signup", {});
                            this.$gtm.push({
                                'event': 'UETRegistration',
                                'ecomm_pagetype': 'conversion'
                            });
                        }
                    }).catch(err => {
                        this.isLoading = false;
                        if (err.status === 400) {
                            this.errorMsg = 'Email is already in use.';
                        } else {
                            this.errorMsg = 'Please try again.';
                        }
                    })
                } else {
                    this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                }
            } else {
                this.errorMsg = 'Please fill the above information.';
            }
        },
        ...mapActions({
            signup: AAuth.REG_USER,
            sendMail: AAuth.SEND_MAIL
        })
    },
    mounted() {
        this.isBrowser = process.browser
    }
}
</script>

<style scoped>
.login-success {
    text-align: center;
    background: url('../assets/success_icon.png') no-repeat center 30px;
    padding: 140px 32px 0;
}
.login-success-btn-wrapper {
    margin-top: 40px;
    text-align: center;
}
.login-success-btn-wrapper .btn-bid-proceed.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background-color: var(--brand);
    color: #ffffff;
    min-width: 150px;
    margin-right: 15px;
}
.login-success-btn-wrapper .btn-bid-cancel.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}
.registration-right .submit {
    width: 320px;
    height: 40px;
    letter-spacing: 0;
    box-shadow: none;
    margin-left: 0;
    margin-right: 0;
    margin-top: 16px;
    background: #E2C477;
    border-radius: 4px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}
.check-terms {
    margin-top: 6px;
}
.check-terms2 {
    margin-top: 16px;
}
.login-label {
    position: absolute;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 10px;
    color: #000000;
}
.registration-wrapper {
    margin-top: 50px;
    padding: 5px;
    border-radius: 8px;
    -webkit-box-shadow: 5px 5px 15px 10px #c8c8c8;
    box-shadow: 5px 5px 15px 10px #c8c8c8;
}
.registration-left,
.registration-right {
    display: inline-block;
    width: calc((100% - 4px) / 2);
    padding: 32px;
    vertical-align: top;
}
.reg-title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    color: #004870;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 32px;
}
.reg-title span {
    text-decoration: underline;
}
.reg-valid {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    margin-bottom: 20px;
}
.reg-info {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
}
.reg-info a {
    color: #D92133;
    text-decoration: none;
}
.last-section {
    margin: 100px 0 0;
}
.grace-container {
    padding-top: 80px;
}
.invest-row {
    margin: 0 104px;
}
.invest-box {
    display: inline-block;
    width: calc((100% - 104px) / 3);
    margin-bottom: 60px;
    background: #FFFFFF;
    vertical-align: top;
    position: relative;
    padding-left: 70px;
    text-align: left;
}
.invest-row > .invest-box:nth-child(1),
.invest-row > .invest-box:nth-child(2) {
    margin-right: 48px;
}
.invest-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 55px;
    height: 42px;
    background: url('../assets/check.png') no-repeat center;
}
.invest-title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #101010;
    margin-bottom: 24px;
    padding: 0 8px;
}
.invest-text {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #555555;
}
.start-btn {
    height: 40px;
    background: #004F7F;
    border-radius: 4px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
    padding: 12px 16px;
    margin: 48px auto;
    max-width: 243px;
}
.start-btn:hover {
    cursor: pointer;
    background: #e6c67c;
}
.how-it-works-row {
    height: 116px;
}
.mobileapp-container.mobileapp-container-short {
    max-width: 440px;
}
.mobileapp-container.mobileapp-container-short2 {
    max-width: 1080px;
}
.dash {
    width: 2px;
    height: 48px;
    background: #004F7F;
    margin: 16px 0 16px 57px;
}
.how-it-works-row-center {
    width: 116px;
    height: 116px;
    margin: 0 48px 0 0;
}
.how-it-works-row-left,
.how-it-works-row-center,
.how-it-works-row-right {
    display: inline-block;
}
.how-it-works-row-left,
.how-it-works-row-right {
    width: calc(100% - 169px);
    height: 116px;
    vertical-align: top;
}
.how-it-works-row-right {
    text-align: left;
}
.icon1 {
    background: url('../assets/landing/grace/icon1.png') no-repeat center;
}
.icon2 {
    background: url('../assets/landing/grace/icon2.png') no-repeat center;
}
.icon3 {
    background: url('../assets/landing/grace/icon3.png') no-repeat center;
}
.icon4 {
    background: url('../assets/landing/grace/icon4.png') no-repeat center;
}
.how-title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 29px;
    color: rgba(0, 0, 0, 0.88);
    max-width: 394px;
}
.how-title1 {
    margin-top: 12px;
}
.how-subtitle {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.64);
    max-width: 394px;
    margin-top: 16px;
}
.how-it-works-row-left .how-title,
.how-it-works-row-left .how-subtitle {
    margin-left: calc(100% - 394px);
}
.featured {
    background-color: #f6f6f6;
    padding: 1px;
}
.vindome-app-icon {
    width: 118px;
    height: 117px;
    position: absolute;
    bottom: -59px;
    margin: 0 auto;
    left: 0;
    right: 0;
    background: url('../assets/landing/vlogo.png') no-repeat center;
}
.home-download-android,
.home-download-ios {
    display: inline-block;
    width: 163px;
    height: 48px;
}
.home-download-ios {
    background: url('../assets/app/appstore.png') no-repeat center;
    width: 144px;
    margin-right: 16px;
}
.home-download-android {
    background: url('../assets/app/gplay.png') no-repeat center;
}
.home-download-android:hover,
.home-download-ios:hover {
    cursor: pointer;
}
.download-btn-wrapper {
    margin: 50px auto 0;
    text-align: center;
}
.download-btn-wrapper {
    margin: 0 auto 50px;
    text-align: center;
}
.home-download-android,
.home-download-ios {
    display: inline-block;
    width: 163px;
    height: 48px;
}
.home-download-ios {
    background: url('../assets/app/appstore.png') no-repeat center;
    width: 144px;
    margin-right: 16px;
}
.home-download-android {
    background: url('../assets/app/gplay.png') no-repeat center;
}
.home-download-android:hover,
.home-download-ios:hover {
    cursor: pointer;
}
.slogan {
    height: 672px;
    position: relative;
}
.slogan-img {
    background: url('../assets/landing/lp11.png') no-repeat center top;
    background-size: cover;
    width: 100%;
    height: 100%;
}
.slogan-img-shadow {
    background: rgba(24,79,126,0.6);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.main-title-wrapper {
    position: absolute;
    top: 50px;
    width: 1366px;
    height: calc(100% - 96px);
    max-width: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 0 15px;
}
.main-title-wrapper-left,
.main-title-wrapper-right {
    display: inline-block;
    width: calc((100% - 4px) / 2);
    padding: 0 60px;
    vertical-align: top;
}
.main-title-wrapper-right {
    background: url('../assets/landing/lp_iphone.png') no-repeat center;
    height: 100%;
    background-size: contain;
}
.main-title {
    width: 100%;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 42px;
    display: block;
    color: #FFFFFF;
    margin-top: 90px;
    margin-bottom: 40px;
}
.main-subtitle {
    width: 100%;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    color: #FFFFFF;
    text-align: left;
    font-size: 24px;
    line-height: 28px;
}
h2 {
    color: #707070;
    margin-bottom: calc(2*var(--gutter));
}
.home-title-wine {
    text-align: center;
    margin: 61px auto;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 120%;
    color: #004870;
}
.mobileapp-testimonials {
    background: #F6F6F6;
    height: 488px;
}
.mobileapp-testimonials .contactus-title2 {
    padding-top: 44px;
    margin-top: 0;
}
.testimonial-text {
    max-width: 1024px;
    margin: 0 auto;
    font-size: 17px;
    line-height: 22px;
}
.testimonial-name {
    color: #303030;
    font-weight: 700;
    font-size: 14px;
}
.testimonial-logo {
    width: 161px;
    height: 89px;
    margin: 0 auto 19px;
}
.logo-decanter {
    background: url('../assets/app/decanter.png') no-repeat center;
}
.logo-winespectator {
    background: url('../assets/app/winespectator.png') no-repeat center;
}
.logo-saveur {
    background: url('../assets/app/saveur.png') no-repeat center;
}

.logo-larepubblica {
    background: url('../assets/app/larepubblica.png') no-repeat center;
    background-size: contain;
}
.logo-ilgiornale {
    background: url('../assets/app/ilgiornale.png') no-repeat center;
    background-size: contain;
}
.logo-businessinsider {
    background: url('../assets/app/businessinsider.png') no-repeat center;
    background-size: contain;
}
.logo-cosmopolitan {
    background: url('../assets/app/cosmopolitan.png') no-repeat center;
    background-size: contain;
}
.logo-digitalclub {
    background: url('../assets/app/digitalclub.png') no-repeat center;
    background-size: contain;
}
.logo-mixerplanet {
    background: url('../assets/app/mixerplanet.png') no-repeat center;
    background-size: contain;
}
.logo-igrandivini {
    background: url('../assets/app/igrandivini.png') no-repeat center;
    background-size: contain;
}
.logo-vanityfair {
    background: url('../assets/app/vanityfair.svg') no-repeat center;
    background-size: contain;
}
.logo-winenews {
    background: url('../assets/app/winenews.png') no-repeat center;
    background-size: contain;
}
.logo-dagospia {
    background: url('../assets/app/dagospia.png') no-repeat center;
    background-size: contain;
}
.logo-vice {
    background: url('../assets/app/vice.svg') no-repeat center;
    background-size: contain;
}
.logo-rssmagazine {
    background: url('../assets/app/rss.png') no-repeat center;
    background-size: contain;
}
.logo-startup {
    background: url('../assets/app/startup.png') no-repeat center;
    background-size: contain;
}
.logo-jamesmagazine {
    background: url('../assets/app/jamesmagazine.png') no-repeat center;
    background-size: contain;
}
.testimonial-info {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 19px;
    line-height: 120%;
    color: #303030;
    text-align: center;
}
.mobileapp-container {
    max-width: 1366px;
    margin: 0 auto;
}

@media (max-width: 767px) {
    .reg-title {
        font-size: 22px;
    }
    .dash {
        margin: 16px auto;
    }
    .main-title-wrapper-left,
    .main-title-wrapper-right,
    .registration-left,
    .registration-right {
        display: block;
        width: 100%;
    }
    .main-title-wrapper-left,
    .main-title-wrapper-right {
        padding: 0 10px;
    }
    .last-section {
        margin-bottom: 0;
    }
    .download-btn-wrapper {
        margin-bottom: 40px;
    }
    .slogan {
        height: 475px;
    }
    .vindome-app-icon {
        height: 64px;
        width: 64px;
        bottom: -32px;
        background-size: contain;
    }
    .main-title {
        font-size: 24px;
        line-height: 100%;
        margin-top: 0;
        margin-bottom: 20px;
    }
    .registration-wrapper {
        margin: 250px 15px 0;
    }
    .main-subtitle {
        font-size: 18px;
    }
    .main-title-wrapper {
        top: 24px;
    }
    .home-title-wine {
        font-size: 18px;
        line-height: 120%;
        margin: 41px auto;
        padding: 0 20px;
        max-width: 335px;
    }
    .how-it-works-row-center {
        margin: 0 auto;
        display: block;
    }
    .how-title {
        margin: 16px auto;
        display: block;
        text-align: center;
        font-size: 18px;
    }
    .how-subtitle {
        margin: 0 auto;
        display: block;
        text-align: center;
    }
    .how-title,
    .how-subtitle {
        padding: 0 12px;
    }
    .invest-box {
        width: calc(100% - 100px);
        margin: 16px;
    }
    .registration-right .submit {
        width: 100%
    }
}
</style>
<style>
.page-landing-grace .v-main {
    padding-top: 0 !important;
}
.page-landing-grace .not-logged-btn-wrapper .header-login-btn,
.page-landing-grace .cart-item-not-logged {
    display: none;
}
.page-landing-grace .site-navigation-not-logged {
    position: absolute;
    right: 32px;
    top: 24px;
}
.page-landing-grace .site-navigation-not-logged li {
    display: none;
}
.page-landing-grace .site-navigation-not-logged li.lang-nav {
    display: block;
    margin-left: 0;
    margin-right: 0;
}

.page-landing-grace .flex {
    margin-top: 15px;
    text-align: left;
    position: relative;
}
.page-landing-grace .v-text-field__details {
    bottom: -7px;
    position: absolute;
}
.page-landing-grace .v-input input {
    height: 40px;
    max-height: unset;
    margin-top: 4px;
    padding-left: 15px;
}
.page-landing-grace .v-text-field .v-input__append-inner {
    margin-top: 4px;
    background: #fff;
    height: 40px;
}
.page-landing-grace .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 8px;
    margin-right: 3px;
}
.page-landing-grace .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}
.page-landing-grace .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}
.page-landing-grace .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before {
    border-color: var(--brand);
}
.page-landing-grace .theme--light.v-text-field>.v-input__control>.v-input__slot:after {
    border-color: rgba(0,0,0,.87);
    border-width: 1px;
}
.page-landing-grace .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after {
    border-color: #ff5252;
}
.page-landing-grace .footer-links a,
.page-landing-grace .check-terms a {
    text-decoration: none;
    color: #707070;
    font-size: 19px;
    font-weight: 300;
}
.page-landing-grace .footer-links a:hover,
.page-landing-grace .check-terms a:hover {
    color: var(--brand);
}
.theme--light.v-application.loginpage {
    background: #ffffff;
}
.page-landing-grace .v-input--checkbox .v-messages {
    display: none;
}

.page-landing-grace .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 6px;
}
.page-landing-grace .v-input input[type=checkbox] {
    width: 18px;
    height: 18px;
}

.page-landing-grace .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot .v-icon.v-icon {
    font-size: 18px;
}

.page-landing-grace .v-input--selection-controls__input {
    margin-right: 0;
}

.page-landing-grace .v-application .accent--text {
    color: #E2C477 !important;
    caret-color: #E2C477 !important;
}

.swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    height: 300px;
    width: 100%;
}
.show-mobile .swiper-container {
    height: 360px;
}
.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform;
    box-sizing: content-box;
}

.swiper-container-no-flexbox .swiper-slide {
    float: left
}

.swiper-container-vertical>.swiper-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform;
    box-sizing: content-box
}

.swiper-container-android .swiper-slide,.swiper-wrapper {
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
}

.swiper-container-multirow>.swiper-wrapper {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.swiper-container-free-mode>.swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto
}

.swiper-slide {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform
}

.swiper-slide.swiper-slide-active .testimonial-item {
    border-right: 1px solid #F0F0F0;
    padding-left: 0;
    padding-right: 45px;
}

.show-mobile .swiper-slide.swiper-slide-active .testimonial-item {
    border-right: 0;
    padding-right: 0;
}

.swiper-invisible-blank-slide {
    visibility: hidden
}

.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide {
    height: auto
}

.swiper-container-autoheight .swiper-wrapper {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    transition-property: height,-webkit-transform;
    transition-property: transform,height;
    transition-property: transform,height,-webkit-transform
}

.swiper-container-3d {
    -webkit-perspective: 1200px;
    perspective: 1200px
}

.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper {
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
}

.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10
}

.swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(270deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(90deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(0deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(180deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper {
    -ms-touch-action: pan-y;
    touch-action: pan-y
}

.swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper {
    -ms-touch-action: pan-x;
    touch-action: pan-x
}

.swiper-button-next,.swiper-button-prev {
    position: absolute;
    top: 50%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: 50%;
    background-repeat: no-repeat
}

.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled {
    opacity: .35;
    cursor: auto;
    pointer-events: none
}

.swiper-button-prev,.swiper-container-rtl .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
    left: 50px;
    right: auto
}

.swiper-button-next,.swiper-container-rtl .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
    right: 50px;
    left: auto
}

.swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
}

.swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
}

.swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
}

.swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
}

.swiper-pagination {
    position: absolute;
    text-align: center;
    transition: opacity .3s;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 10
}

.swiper-pagination.swiper-pagination-hidden {
    opacity: 0
}

.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
    bottom: 10px;
    left: 0;
    width: 100%
}

.carousel-wrapper {
    height: 480px;
    position: relative;
}

@media (max-width: 767px) {
    .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
        bottom: 0;
    }
}

.swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    -webkit-transform: scale(.33);
    transform: scale(.33);
    position: relative
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    -webkit-transform: scale(.66);
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    -webkit-transform: scale(.33);
    transform: scale(.33)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    -webkit-transform: scale(.66);
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    -webkit-transform: scale(.33);
    transform: scale(.33)
}

.swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: .2
}

button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none
}

.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: #007aff
}

.swiper-container-vertical>.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    -webkit-transform: translate3d(0,-50%,0);
    transform: translate3d(0,-50%,0)
}

.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 6px 0;
    display: block
}

.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 8px
}

.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    display: inline-block;
    transition: top .2s,-webkit-transform .2s;
    transition: transform .2s,top .2s;
    transition: transform .2s,top .2s,-webkit-transform .2s
}

.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px
}

.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    white-space: nowrap
}

.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: left .2s,-webkit-transform .2s;
    transition: transform .2s,left .2s;
    transition: transform .2s,left .2s,-webkit-transform .2s
}

.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: right .2s,-webkit-transform .2s;
    transition: transform .2s,right .2s;
    transition: transform .2s,right .2s,-webkit-transform .2s
}

.swiper-pagination-progressbar {
    background: rgba(0,0,0,.25);
    position: absolute
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #007aff;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top;
    transform-origin: left top
}

.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    -webkit-transform-origin: right top;
    transform-origin: right top
}

.swiper-container-horizontal>.swiper-pagination-progressbar {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0
}

.swiper-container-vertical>.swiper-pagination-progressbar {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0
}

.swiper-pagination-white .swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination-progressbar.swiper-pagination-white {
    background: hsla(0,0%,100%,.25)
}

.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
    background: #fff
}

.swiper-pagination-black .swiper-pagination-bullet-active {
    background: #000
}

.swiper-pagination-progressbar.swiper-pagination-black {
    background: rgba(0,0,0,.25)
}

.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
    background: #000
}

.swiper-scrollbar {
    border-radius: 10px;
    position: relative;
    -ms-touch-action: none;
    background: rgba(0,0,0,.1)
}

.swiper-container-horizontal>.swiper-scrollbar {
    position: absolute;
    left: 1%;
    bottom: 3px;
    z-index: 50;
    height: 5px;
    width: 98%
}

.swiper-container-vertical>.swiper-scrollbar {
    position: absolute;
    right: 3px;
    top: 1%;
    z-index: 50;
    width: 5px;
    height: 98%
}

.swiper-scrollbar-drag {
    height: 100%;
    width: 100%;
    position: relative;
    background: rgba(0,0,0,.5);
    border-radius: 10px;
    left: 0;
    top: 0
}

.swiper-scrollbar-cursor-drag {
    cursor: move
}

.swiper-zoom-container {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center
}

.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg {
    max-width: 100%;
    max-height: 100%;
    -o-object-fit: contain;
    object-fit: contain
}

.swiper-slide-zoomed {
    cursor: move
}

.swiper-lazy-preloader {
    width: 42px;
    height: 42px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -21px;
    margin-top: -21px;
    z-index: 10;
    -webkit-transform-origin: 50%;
    transform-origin: 50%;
    -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
    animation: swiper-preloader-spin 1s steps(12) infinite
}

.swiper-lazy-preloader:after {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
    background-position: 50%;
    background-size: 100%;
    background-repeat: no-repeat
}

.swiper-lazy-preloader-white:after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
}

@-webkit-keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

.swiper-container .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
    transition-timing-function: ease-out
}

.swiper-container-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity
}

.swiper-container-fade .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube {
    overflow: visible
}

.swiper-container-cube .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
    visibility: hidden;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 100%;
    height: 100%
}

.swiper-container-cube .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0
}

.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev {
    pointer-events: auto;
    visibility: visible
}

.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
}

.swiper-container-cube .swiper-cube-shadow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .6;
    -webkit-filter: blur(50px);
    filter: blur(50px);
    z-index: 0
}

.swiper-container-flip {
    overflow: visible
}

.swiper-container-flip .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1
}

.swiper-container-flip .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
}

.swiper-container-coverflow .swiper-wrapper {
    -ms-perspective: 1200px
}

@media (max-width: 767px) {
    .page-landing-grace .locale-changer {
        position: absolute;
        top: 5px;
        right: 10px;
    }
    .page-landing-grace .v-application .hidden-md-and-up {
        display: none !important;
    }
    .page-landing-grace .theme--dark.v-sheet.header-toolbar,
    .page-landing-grace .theme--dark.v-sheet.header-toolbar .v-toolbar__content {
        height: 40px !important;
    }
    .page-landing-grace .theme--dark.v-sheet.header-toolbar .logo img {
        margin-left: 10px;
        margin-top: 3px;
    }
    .page-landing-grace .swiper-container {
        height: 280px;
    }
    .page-landing-grace .nav-second-row,
    .page-landing-grace .site-navigation-wrapper {
        display: block;
    }
}
</style>
